import MuiContainer from '@material-ui/core/Container';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme: { font } }) => font.mainFont()};
  background:
    radial-gradient(120% 120% at 20% 0%, rgba(191, 219, 254, 0.4) 0%, rgba(191, 219, 254, 0) 60%),
    radial-gradient(120% 120% at 100% 100%, rgba(186, 230, 253, 0.55) 0%, rgba(186, 230, 253, 0) 62%),
    linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);
  color: #0f172a;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 24px;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  text-align: center;
  padding: 0 0 24px;
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      display: block;
      padding: 0 0 16px;
    }
  `}
`;

export const Img = styled.img`
  width: min(100%, 138px);
  background: linear-gradient(145deg, #2563eb 0%, #38bdf8 100%);
  border-radius: 24px;
  box-shadow: 0 16px 30px rgba(37, 99, 235, 0.24);
  padding: 16px;
  margin-bottom: 22px;
  margin-top: 2px;
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      margin: 4px auto 20px;
    }
  `}
`;

export const Header = styled.header`
  width: 100%;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.22);
  padding: 18px 24px 12px;
  text-align: center;
`;

export const Title = styled.h2`
  color: #0f172a;
  font-weight: 700;
  font-size: clamp(30px, 5vw, 38px);
  line-height: 1.18;
  margin-top: 8px;
  margin-bottom: 10px;

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('xs')} {
      font-size: 28px;
    }
  `}
`;

export const Description = styled.p`
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #475569;
  max-width: 520px;
  margin-block-start: 0;
  margin-bottom: 0;
`;

export const Container = styled(MuiContainer)`
  && {
    backdrop-filter: blur(8px);
    background: rgba(255, 255, 255, 0.86);
    border: 1px solid rgba(226, 232, 240, 0.95);
    border-radius: 30px;
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.1);
    align-items: center;
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    justify-content: flex-start;
    margin: 14px auto 28px;
    min-height: auto;
    max-width: 520px;
    padding: 34px 24px 30px;

    ${({ theme: { mui } }) => css`
      ${mui.breakpoints.down('sm')} {
        border-radius: 26px;
        margin: 8px 12px 20px;
        min-height: auto;
        padding: 30px 18px 24px;
      }
    `}
  }
`;

export const BackToHome = styled.span`
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  text-transform: none;
  border: none;
  box-sizing: border-box;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.2);
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 0;
  margin-top: 28px;
  max-width: 360px;
  padding: 14px 16px;
  text-decoration: none;
  width: 100%;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 14px 28px rgba(15, 23, 42, 0.24);
  }

  &:active {
    transform: scale(0.985);
  }

  > span {
    color: #ffffff;
  }
`;

export const Supporter = styled.a`
  color: #0f172a;
  font-weight: 700;
  padding: 0 6px;
  text-decoration: none;
`;
export const FeedbackLink = styled.span`
  cursor: pointer;
`;
